import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, search, nullsafe, assertUnreachable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FirmaCadenaComponent } from "app/features/componentes/firmacadena";

class InfoEntregaCompSimple extends React.PureComponent<{ value: models.InfoEntregaZE }> {
    render() {
        const x = this.props.value;
        const textoAcuses =
            x.AcusesEntregar.length > 0 ?
                x.AcusesEntregar.map(x => `${x.Folio} (${x.TipoAcuse == models.TipoAcuse.Interno ? "Interno" : ("Externo, " + x.RequerimientoAcuse)})`).join(", ") :
                "(ninguno)";

        return (
            <div>
                <kea.Panel title="Información" style="primary">
                    <h4>
                        Status:{" "}
                        <b>
                            {
                                x.Finalizado ? "Entrega finalizada" :
                                    x.GuiasExcluidas ? "Faltan algunas guias" : "Listo para finalizar"
                            }
                        </b>
                        <br />
                        Acuses:{" "}<b>{textoAcuses}</b>
                    </h4>
                    <hr />
                    <label>Cliente:</label>{" "}{x.NombreCliente}<br />
                    <label>Dirección:</label>{" "}{x.NombreDestino}<br />
                    {
                        x.Finalizado && false &&
                        <FirmaCadenaComponent label="Firma" value={x.Firma} />
                    }
                </kea.Panel>
            </div>
        );
    }
}

export const InfoEntregaComp = componentToRx(InfoEntregaCompSimple);





// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeappZE/entrega/info.tsx